import { Box, Typography } from "@mui/material";
// config
import colors from "../../../config/colors";
// redux
import { useDispatch } from "../../../redux/store";
import {
  setCreatorDetails,
  setSelectedContent,
  setSimilarCreatorDetails,
} from "../../../redux/slices/creator";
// ga
import {
  triggerGa,
  CATEGORY,
  ACTION,
  PAGE,
  SCREEN,
  LABEL,
  LABEL2,
} from "../../../utils/gaUtils";
import { getAssetUrl } from "../../../utils/helpers";
import { useState } from "react";

const RecentPosts = ({ item, type = "creator-details", viewType = "list" }) => {
  const dispatch = useDispatch();
  const topPosts = item?.top_posts || [];
  const recentPosts = topPosts?.slice(0, 3);
  const placeholder = getAssetUrl("Placeholder.png");

  const [errorMap, setErrorMap] = useState({});

  const handleImgError = (index) => (e) => {
    if (errorMap[index]) return;
    setErrorMap((prev) => ({ ...prev, [index]: true }));
    e.currentTarget.src = placeholder;
  };

  const handlePostClick = (e, post) => {
    triggerGa({
      category: CATEGORY.USER_INTERACTION,
      action: ACTION.RECENT_POST_CLICK,
      label: item?.username,
      label2: post?.permalink,
      label3: LABEL2.PROFILE_INTEREST,
      page: PAGE.CREATOR_DISCOVER,
      screenName:
        viewType === "card" ? SCREEN.DISCOVER_CARD : SCREEN.DISCOVER_LIST,
    });
    e.stopPropagation();
    if (type === "creator-details") {
      dispatch(setCreatorDetails({ ...item, selectedTab: "content" }));
    } else {
      dispatch(setSimilarCreatorDetails({ ...item, selectedTab: "content" }));
    }

    dispatch(setSelectedContent(post));
  };

  const getPostImageSrc = (post) => {
    const thumb = post?.thumbnail_url;
    if (thumb) return thumb;

    const media = post?.media_url;
    if (!media) return placeholder;

    // treat as image if URL ends with an image extension (ignoring query/hash)
    const clean = String(media).split("?")[0].split("#")[0];
    const isImage = /\.(png|jpe?g|webp|gif)$/i.test(clean);

    return isImage ? media : placeholder;
  };

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      {topPosts?.length > 0 && (
        <Box
          sx={{
            display: "flex",
            flexWrap: "nowrap",
            gap: 1,
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          {recentPosts?.map((post, index) => (
            <Box
              key={post?.post_id || index}
              component="img"
              src={getPostImageSrc(post)}
              onError={handleImgError(index)}
              alt={`Post ${index + 1}`}
              sx={{
                aspectRatio: viewType === "card" ? "63 / 96" : "1 / 1",
                width: viewType === "card" ? "calc((100% - 16px) / 3)" : "48px",
                flex: viewType === "card" ? "1" : "none",
                maxWidth:
                  viewType === "card" ? "calc((100% - 16px) / 3)" : "100%",
                borderRadius: 1,
                objectFit: "cover",
                flexShrink: 0,
                border: `1px solid ${colors.gray100}`,
                cursor: "pointer",
                "&:hover": {
                  borderColor: colors.primary500,
                  transform: "scale(1.05)",
                  transition: "all 0.2s ease",
                },
              }}
              onClick={(e) => handlePostClick(e, post)}
            />
          ))}
        </Box>
      )}

      {recentPosts?.length === 0 && (
        <Box
          height={48}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography fontSize={10} color={colors.gray200} textAlign="center">
            No recent posts
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default RecentPosts;
